import { React, useEffect } from "react";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";

import PrintMockup from "../img/herectus_mockup.png";
import Headshot from "../img/HErectus_headshot.png";
import HErectusEcorche from "../img/herectus_ecorche_paired.png";
import HErectusSkull from "../img/herectus_skull_paired.png";
import TissueDepth from "../img/tissue_depth.png";
import TissueData from "../img/tissue_data.png";
import HErectusWide from "../img/herectus_wide.jpg";

function HErectus() {
  useEffect(() => {
    document.title =
      "ETCHNG | Predicting Peking Man: An anthropological approximation of H. erectus using forensic data";
  }, []);
  return (
    <>
      <HeroHeader
        hero_img={PrintMockup}
        type="Print spread —"
        name="Predicting Peking Man: An anthropological approximation of "
        italics="H. erectus"
        name2=" using forensic data" // name="Predicting Peking Man: An anthropological approximation of <i>H. erectus</i> using forensic data"
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
                <div className="work__info__basic__item">
                  {" "}
                  <h5>Date</h5>
                  <p>Nov 2019 </p>{" "}
                </div>
                <div className="work__info__basic__item">
                  {" "}
                  <h5>Role</h5>
                  <p>3D artist</p>
                </div>
                <div className="work__info__basic__item">
                  {" "}
                  <h5>Tools</h5>
                  <p>Blender, ZBrush</p>
                </div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>
                Peking Man <i>(Homo erectus pekinensis)</i> is a composite of
                200 <i>H. erectus</i> fossils belonging to over 40 young adults,
                dated to approximately 0.40–0.78 million years ago, and found in
                China’s Zhoukoudian site.
              </p>
            </div>
          </div>
          <div className="work">
            <div className="work__info twoColumn">
              <h4>CHALLENGE</h4>
            </div>
            <div className="work__info twoColumn">
              <p>
                Forensic facial approximation, or facial reconstruction, is the
                process of "reconstructing" soft tissue onto human remains to
                help produce a potential positive identification of what an
                individual might have looked like when alive.
              </p>
              <p>
                The purpose of this project was to reconcile and apply digital
                sculpting techniques with knowledge of anatomy, anthropology,
                and osteology to produce an informed forensic facial
                approximation of Peking Man.
              </p>

              <p>
                {" "}
                It won a{" "}
                <a
                  href="https://meetingarchive.ami.org/2020/salon-awards/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Merit Award at the Association of Medical Illustrators 2020
                  Salon.
                </a>
              </p>
            </div>
          </div>

          <div className="work">
            <div className="work__info">
              <h4>PROCESS</h4>
            </div>
          </div>
          <div className="work">
            <div className="work__info narrowColumn">
              <p>
                This was accomplished by first performing research in
                anthropological and forensic literature to understand the key
                points on the skull that soft tissues attach, and define the
                contours of the face.
              </p>
            </div>
            <div className="work__info wideColumn">
              <img
                src={TissueDepth}
                loading="lazy"
                alt="Diagram of referenced skull bony landmarks and and markers for soft tissue depth."
              ></img>
            </div>
          </div>

          <div className="work">
            <img
              src={TissueData}
              loading="lazy"
              alt="Table of average soft tissue depth at different skull landmarks"
            ></img>
          </div>

          <div className="work">
            <div className="work__info narrowColumn">
              <p>
                I then placed virtual pegs that represented the average soft
                tissue thickness for a modern human male at their corresponding
                bony landmarks on the scanned replica skull to help contour the
                facial anatomy.
              </p>
            </div>
            <div className="work__info wideColumn">
              <img
                src={HErectusSkull}
                loading="lazy"
                alt="Skull of Homo erectus pekinensis with tissue depth markers"
              ></img>
            </div>
          </div>
          <div className="work">
            <div className="work__info wideColumn">
              <img
                src={HErectusEcorche}
                loading="lazy"
                alt="Skull of Homo erectus pekinensis with tissue depth markers"
              ></img>
            </div>
            <div className="work__info narrowColumn">
              <p>
                Regression equations were used to predict nasal morphology. By
                fleshing out a face and supporting it with the anatomical
                reasoning involved, this was intended to help better communicate
                a more familiar and relatable visualization of
                paleoanthropological data to a lay audience.
              </p>
            </div>
          </div>

          <div className="work ">
            <div className="work__info narrowColumn">
              <p>
                While not meant to be a direct postcranial reconstruction, an
                accompanying wide shot, informed by more general research on{" "}
                <i>H. erectus</i> anatomy, was included to better contextualize
                and showcase their relatively modern proportions and behaviours.
              </p>
            </div>
           


            <div className="work__info wideColumn">
              <img
                src={Headshot}
                loading="lazy"
                alt="Skull of Homo erectus pekinensis with tissue depth markers"
              ></img>
            </div>
          </div>
          <div className="work singleColumn">

          <img
              src={HErectusWide}
              loading="lazy"
              alt="Skull of Homo erectus pekinensis with tissue depth markers"
            ></img>
          </div>

        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default HErectus;
